/** @deprecated */
export var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["PRIMARY"] = "primary";
    ButtonStyle["DANGER"] = "danger";
})(ButtonStyle || (ButtonStyle = {}));
//# sourceMappingURL=ButtonStyle.js.map